import { MultiDatePicker } from 'components/MyDatePicker/MultiDatePicker';
import { connect, MapDispatchToProps, MapStateToProps } from 'react-redux';
import React from 'react';
import {
  IUserInfos,
  IUserInfo,
} from 'store/makhsanUserInfo/makhsanUserInfoSlice';
import Input from '../Input';
import { CompanyMembersFilterBox } from 'containers/Tasks/CompanyManagement/styles';
import messages from './Messages';
import { Item, UserItems } from './styles';
import { searchRequestLogs } from 'api/MakhsanApi';
import { smartDateString } from 'utils/date';
import LoadingCircleIndicator from '../LoadingCircleIndicator/LoadingCircleIndicator';
import Button from '../Button/Button';
import notify from '../Notify';
import moment from 'moment-jalaali';
import APopover from '../APopover';
import { responseTitleStyle } from '../FileManager/ItemsViewer/Survey/SurveyResponseViewer/styles';
import Collapsible from '../Collapsible';
import useragent from 'useragent';
import { appDispatch, IUsers, RootState } from 'store/store';
import { IThisUserState } from 'store/thisUser/thisUserSlice';
import {
  requireSeveralUser,
  requireSeveralUserFn,
} from 'store/users/usersSlice';
import { IUserRequestLog } from 'store/users/usersType';

interface IStateToProps {
  thisUser: IThisUserState;
  userInfos: IUserInfos;
  users: IUsers['map'];
  store: RootState;
}
interface IDispatchToProps {
  requireSeveralUser: (
    usersList: number[]
  ) => ReturnType<typeof requireSeveralUserFn>;
}

interface IOwnProps {
  user: IUserInfo;
}

const availableApps = ['man', 'makh', 'mess'];

interface IComponentState {
  path?: string;
  app?: string;
  date?: string | null;
  logs: IUserRequestLog[];
  loading?: boolean;
}
type IComponentProps = IStateToProps & IOwnProps & IDispatchToProps;

class AccessLogViewPanel extends React.PureComponent<
  IComponentProps,
  IComponentState
> {
  state: IComponentState = {
    loading: false,
    logs: [],
    date: moment().format('jD jMMMM jYYYY'),
  };
  handleSearch = () => {
    const { path, app, date } = this.state;
    const { user } = this.props;
    this.setState({ loading: true });
    searchRequestLogs(
      this.props.store,
      undefined,
      (moment(date, 'jD jMMMM jYYYY').unix() + 24 * 60 * 60) * 1000,
      user.user_id,
      app ? app : undefined,
      path,
      1000
    ).then(
      (result: any) => {
        this.setState({ loading: false, logs: result.data });
      },
      (e: any) => {
        this.setState({ loading: false });
        notify(e.data.message);
      }
    );
  };

  componentDidUpdate(prevProps: Readonly<IComponentProps>): void {
    if (prevProps.user.user_id !== this.props.user.user_id) this.handleSearch();
  }

  componentDidMount(): void {
    this.handleSearch();
  }
  friendlyUserAgent(agent: string): string {
    return useragent.lookup(agent).toString();
  }

  getStatusMessage(status: number): string {
    if (status < 400) return messages.status_success;
    if (status === 403) return messages.status_denied;
    if (status < 500) return messages.status_failed;
    if (status >= 500) return messages.status_system_error;
    return '';
  }
  render() {
    const { loading, logs, app, path, date } = this.state;
    const { users, requireSeveralUser } = this.props;
    return (
      <div>
        <CompanyMembersFilterBox className=" row ">
          <Input
            id="path"
            type="text"
            onChange={(e) => {
              this.setState({ path: e.target.value });
            }}
            placeholder={messages.path}
            value={path}
            wrapperClassName="search-user-by-name-input col s12 m3"
          />
          <select
            className="browser-default col s12 m1"
            name="module"
            id="module"
            onChange={(e) => {
              this.setState({
                app: e.target.value,
              });
            }}
            value={app}
          >
            <option value="">{messages.module}</option>
            {availableApps.map((a) => (
              <option value={a} key={a}>
                {a}
              </option>
            ))}
          </select>
          <APopover
            arrow
            curveBorder
            trigger="click"
            target={
              <Input
                id="date"
                type="text"
                autoComplete="off"
                required={false}
                placeholder={messages.date}
                value={date || undefined}
              />
            }
          >
            <MultiDatePicker
              value={Number(date) ?? null}
              setDate={(value) =>
                this.setState({
                  date: value ? moment(value).format('jD jMMMM jYYYY') : null,
                })
              }
            />
          </APopover>
          <Button onClick={this.handleSearch}>{messages.search}</Button>
        </CompanyMembersFilterBox>
        <div style={{ display: 'flex' }}>
          {loading ? (
            <LoadingCircleIndicator />
          ) : (
            <UserItems helve={false}>
              {logs.map((log: IUserRequestLog) => {
                let queryParams: any;
                try {
                  queryParams = (
                    <>
                      {log.queryParams &&
                        Object.entries(JSON.parse(log.queryParams)).map(
                          (entity) => {
                            const key = entity[0];
                            let value = entity[1];
                            if (key.endsWith('Date'))
                              value = smartDateString(
                                new Date(Number(value)),
                                true
                              );
                            if (
                              key.endsWith('userId') ||
                              key.endsWith('UserId')
                            ) {
                              value =
                                users[Number(value)].name || Number(value);
                              if (value === Number(value)) {
                                requireSeveralUser([Number(value)]);
                              }
                            }

                            return (
                              <tr key={key}>
                                <td>{key}</td>
                                <td>{value as any}</td>
                              </tr>
                            );
                          }
                        )}
                    </>
                  );
                } catch (e) {
                  queryParams = <td>{log.queryParams}</td>;
                }

                return (
                  <Collapsible
                    headerBackgroundColor="var(--tertiary-gray)"
                    customHeaderStyle={responseTitleStyle}
                    defaultOpen={false}
                    key={log.id.toString()}
                    header={
                      <React.Fragment>
                        <Item
                          className="row"
                          isActive={false}
                          style={{ width: '100%' }}
                        >
                          <div className="col s12 m6">
                            {messages.date +
                              ': ' +
                              smartDateString(new Date(log.date), true)}
                          </div>
                          <div className="col s12 m6">
                            {messages.statusCode +
                              ': ' +
                              this.getStatusMessage(log.statusCode)}
                          </div>
                          <div className="col s12 m12">
                            {messages.endpointPath +
                              ': ' +
                              (log.endpointPath || '-')}
                          </div>
                        </Item>
                      </React.Fragment>
                    }
                  >
                    <Item
                      className="row"
                      key={log.id.toString() + 'in'}
                      isActive={false}
                    >
                      <div className="col s12 m6 ">
                        {messages.ip + ': ' + (log.ip || '-')}
                      </div>
                      <div className="col s12 m6 ">
                        {messages.appName + ': ' + log.appName || '-'}
                      </div>
                      <div className="col s12 m12">
                        <table>{queryParams}</table>
                      </div>
                      <div className="col s12 m12  ">
                        {messages.userAgent +
                          ': ' +
                          (this.friendlyUserAgent(log.userAgent) || '-')}
                      </div>
                    </Item>
                  </Collapsible>
                );
              })}
            </UserItems>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps: MapStateToProps<IStateToProps, IOwnProps, RootState> = (
  state
) => {
  const userInfos = state.makhsanUserInfo;
  const thisUser = state.thisUser;
  const users = state.users.map;
  return { userInfos: userInfos, thisUser, store: state, users };
};

const mapDispatchToProps: MapDispatchToProps<
  IDispatchToProps,
  IOwnProps
> = () => ({
  requireSeveralUser: (usersList: number[]) =>
    appDispatch(requireSeveralUser({ usersList })),
});

export default connect(mapStateToProps, mapDispatchToProps)(AccessLogViewPanel);
